'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import Link from 'next/link.js';
import '../../util/formatters/format-date.js';
import 'date-fns';
import 'date-fns/locale';
import '../../util/datetime/constants.js';
import '../../util/datetime/comparators.js';
import { formatTimeFromMinutes } from '../../util/formatters/format-time-from-minutes.js';
import '../../types/order.js';

const TimeBalanceSection = ({ className, href, timeRemainingInMinutes, }) => (jsxs(Link, { className: `${className} leading-tight`, href: href, children: [jsx("p", { className: "text-lg font-medium text-leland-gray-dark", children: formatTimeFromMinutes(timeRemainingInMinutes, { showZeroUnits: true }) }), jsx("p", { className: "text-leland-gray-light", children: "On your balance" })] }));

export { TimeBalanceSection };
//# sourceMappingURL=time-balance-section.js.map
